<div class="container ecomm-bck">
    <div class="wrap2" style="overflow:visible">

        <a onclick="window.print()" class="print">
            <img src="assets/images/pdf.png" width="35" height="50" alt="Print this page" title="Print this page" /></a>


        <h1>Cruise Availability</h1>
        <div class="row-powered-by-container">

            <p>Showing tour options:</p>
            <img src="assets/images/powered-by-galavail.svg" alt="powered-by" />
        </div>
        <div id="no-more-tables">
            <table class="table preload table-sm table-striped bg-white border-bottom position-relative text-center">
                <thead>
                    <tr class="text-white">
                        <!--style="background-color: #00556a"-->
                        <th colspan="2" class="bg-dark">Dates</th>
                        <th class="bg-dark">Cruise</th>
                        <th class="bg-dark">Length</th>
                        <th class="bg-dark">Avail</th>
                        <th class="bg-dark">Hold</th>
                        <th class="bg-dark">Sold</th>
                        <th class="bg-dark">Promotion*</th>
                        <th class="bg-dark">Price pp. from</th>
                        <th class="bg-dark" id="empty">&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class='month' data-title='Month:'>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tableDays' data-title='Dates:'>
                            <div class="text w-100 loading-animate"></div><em></em>
                        </td>
                        <td class='tableDays' data-title='Cruise:'>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tableDays ldays' data-title='Length:'>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tableDays' data-title='Available:'>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tableDays' data-title='Hold:'>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tableDays' data-title='Sold:'>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tablePromos' data-title='Promotion:'>
                            <div class="text w-100 loading-animate"></div><span></span>
                        </td>
                        <td class='tablePrice' data-title='Per person from:'><span></span>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tblInquireCol'><a href='checkout-pt1-loading.html' class="inq btn btn-sm btn-danger btn-block mx-lg-auto mt-2">Inquire Here</a><a href="#" class="sml small pt-2">RESERVE NOW</a></td>
                    </tr>
                    <tr>
                        <td class='month' data-title='Month:'>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tableDays' data-title='Dates:'>
                            <div class="text w-100 loading-animate"></div><em></em>
                        </td>
                        <td class='tableDays' data-title='Cruise:'>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tableDays ldays' data-title='Length:'>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tableDays' data-title='Available:'>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tableDays' data-title='Hold:'>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tableDays' data-title='Sold:'>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tablePromos' data-title='Promotion:'>
                            <div class="text w-100 loading-animate"></div><span></span>
                        </td>
                        <td class='tablePrice' data-title='Per person from:'><span></span>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tblInquireCol'><a href='checkout-pt1-loading.html' class="inq btn btn-sm btn-danger btn-block mx-lg-auto mt-2">Inquire Here</a><a href="#" class="sml small pt-2">RESERVE NOW</a></td>
                    </tr>
                    <tr>
                        <td class='month' data-title='Month:'>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tableDays' data-title='Dates:'>
                            <div class="text w-100 loading-animate"></div><em></em>
                        </td>
                        <td class='tableDays' data-title='Cruise:'>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tableDays ldays' data-title='Length:'>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tableDays' data-title='Available:'>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tableDays' data-title='Hold:'>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tableDays' data-title='Sold:'>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tablePromos' data-title='Promotion:'>
                            <div class="text w-100 loading-animate"></div><span></span>
                        </td>
                        <td class='tablePrice' data-title='Per person from:'><span></span>
                            <div class="text w-100 loading-animate"></div>
                        </td>
                        <td class='tblInquireCol'><a href='checkout-pt1-loading.html' class="inq btn btn-sm btn-danger btn-block mx-lg-auto mt-2">Inquire Here</a><a href="#" class="sml small pt-2">RESERVE NOW</a></td>
                    </tr>
                </tbody>
            </table>
            <!-- /Tabla de precarga -->
        </div>
        <div class="avail-note">

        </div>
        <p>&nbsp;</p>
    </div>
</div>
